import React from 'react';
import { observer, inject } from 'mobx-react';
import { FormattedMessage } from 'react-intl';
import css from '@emotion/css';


@inject('settingsStore')
@observer
class ThankYou extends React.Component {
    constructor(props) {
        super(props);
        this.state = {

        };
    }

    render() {

      const {
        settingsStore:{
          userProfile:{
            languageId
          }
        }
        } = this.props;


        return(
          <div
            css={css`
            padding:10px 30px;
            font-size:18px;
            margin-left:50px;
            margin-top:30px;
            `}
          >
            <div css={css`display:flex;flex-direction:column;`}>
              <FormattedMessage id="onboarding.ThankYou.Message" />
              <a
                href={languageId === 'he' ? 'https://chat.whatsapp.com/BatnNj7HNbdKlSD4VHnxpk':'https://chat.whatsapp.com/KMNC6c7uSz7DBHclMcGkva'}
              >
                <FormattedMessage id="onboarding.buttons.whatsapp" />
              </a>
            </div>
          </div>
        )

    }
}

ThankYou.propTypes = {
};

export default ThankYou;